import React, { useEffect, useState } from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';

const MobileBlocker = ({ children }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  if (isMobile) {
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: '#1a1f2e',
        color: '#fff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        textAlign: 'center',
        padding: '32px'
      }}>
        <FaExclamationTriangle size={64} color="#00E0E0" style={{ marginBottom: '1.5rem' }} />
        <h2 style={{ fontSize: '2rem', marginBottom: '1rem', color: '#00E0E0' }}>Unsupported Device</h2>
        <p style={{ fontSize: '1.1rem', maxWidth: 400 }}>
          For the best experience, please use a PC or larger screen. Mobile devices are not supported for this dashboard.
        </p>
      </div>
    );
  }
  return children;
};

export default MobileBlocker; 